const platforms = [
  { icon: "ri-windows-fill", label: "Windows" },
  { icon: "ri-apple-fill", label: "macOS" },
  { icon: "ri-android-fill", label: "Android" },
  { icon: "ri-smartphone-line", label: "iOS" },
];

export default function DownloadBanner() {
  return (
    <section id="download" className="bg-background-100 px-4 py-14 md:px-8 md:py-20">
      <div className="mx-auto max-w-6xl">
        <div className="relative overflow-hidden rounded-lg">
          <img
            src="https://readdy.ai/api/search-image?query=abstract%20editorial%20banner%20background%20with%20layered%20warm%20cream%20paper%20sheets%20and%20deep%20crimson%20red%20strips%2C%20soft%20directional%20light%2C%20fine%20grain%2C%20minimal%20art%20direction%2C%20muted%20warm%20palette%2C%20wide%20panoramic%20composition%2C%20high%20detail&width=1600&height=700&seq=hl-download-bg-01&orientation=landscape"
            alt="黑料图片客户端下载"
            title="下载黑料图片客户端，离线看实锤截图"
            className="absolute inset-0 h-full w-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-black/80 via-black/55 to-black/35" />

          <div className="relative flex flex-col gap-8 px-6 py-10 md:flex-row md:items-center md:justify-between md:px-12 md:py-14">
            <div className="max-w-xl">
              <span className="inline-flex items-center gap-2 rounded-full border border-background-50/25 px-3 py-1 text-[11px] font-medium tracking-widest text-background-100">
                <span className="h-1.5 w-1.5 rounded-full bg-accent-400" />
                客户端 · 图集打包
              </span>
              <h2 className="mt-4 font-heading text-2xl font-black leading-snug text-background-50 md:text-4xl">
                下载客户端
                <br className="hidden md:block" />
                把整组截图存下来慢慢看
              </h2>
              <p className="mt-4 text-sm leading-relaxed text-background-100 md:text-base">
                支持整包缓存、原图放大与截图对照，通勤路上不看刷新也能翻完一整组爆料图片。
              </p>

              <div className="mt-7 flex flex-col gap-3 sm:flex-row">
                <a
                  href="#overview"
                  className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-accent-500 px-6 py-3.5 text-sm font-bold text-foreground-950 transition-colors hover:bg-accent-600"
                >
                  <i className="ri-download-cloud-2-line text-lg" />
                  立即下载
                </a>
                <a
                  href="#faq"
                  className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-50/30 px-6 py-3.5 text-sm font-semibold text-background-50 transition-colors hover:bg-background-50/15"
                >
                  <i className="ri-question-line text-lg" />
                  了解详情
                </a>
              </div>
            </div>

            <div className="grid shrink-0 grid-cols-2 gap-3 md:gap-4">
              {platforms.map((p) => (
                <a
                  key={p.label}
                  href="#overview"
                  className="flex min-w-[128px] items-center gap-3 rounded-md border border-background-50/20 bg-background-50/10 px-4 py-3 backdrop-blur-sm transition-colors hover:bg-background-50/20"
                >
                  <i className={`${p.icon} text-xl text-background-50`} />
                  <span className="text-sm font-medium text-background-50">{p.label}</span>
                </a>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}